"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _warning = _interopRequireDefault(require("warning"));
var _styled = _interopRequireWildcard(require("../styled"));
var _createGridComponent = _interopRequireDefault(require("./createGridComponent"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getWidthValue = function getWidthValue(column, columns, propName) {
  if (typeof column === 'string' && (column === 'auto' || column === 'fluid' || column.endsWith('%'))) {
    // pass literal string 'auto', 'fluid',
    // or a string that ends with '%' as-is.
    return column;
  }
  var intColumn = parseFloat(column);
  if (!isNaN(intColumn)) {
    if (intColumn === 0) {
      // Return 0 as-is
      return intColumn;
    }
    if (intColumn > 0 && intColumn < 1) {
      // between 0 < 1 convert to percentage
      return intColumn * 100 + "%";
    }
    if (intColumn >= 1 && intColumn <= columns) {
      // from 1 up to or equal to column count, calculate
      // percentage based on amount of columns.
      return 100 / columns * intColumn + "%";
    }
  }
  (0, _warning.default)(column == null, "[Column] Invalid value '" + String(column) + "' passed to '" + propName + "'. ");
  return undefined;
};
var getWidth = function getWidth(bp, initial) {
  return function (props) {
    var propName = initial && props.size != null ? 'size' : bp;
    var column = props[propName];
    var columns = props.theme.grid.columns;
    if (column != null) {
      var width = getWidthValue(column, columns, propName);
      if (width != null) {
        switch (width) {
          case 'auto':
            return (0, _styled.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n            flex: 0 0 ", ";\n            width: ", ";\n            max-width: none;\n          "])), width, width);
          case 'fluid':
            return (0, _styled.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n            flex-basis: 0;\n            flex-grow: 1;\n            max-width: 100%;\n          "])));
          default:
            return (0, _styled.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n            flex: 0 0 ", ";\n            max-width: ", ";\n          "])), width, width);
        }
      }
    }
    return undefined;
  };
};
var getOffset = function getOffset(bp, initial) {
  return function (props) {
    var propName = initial && props.offset != null ? 'offset' : bp + "Offset";
    var column = props[propName];
    var columns = props.theme.grid.columns;
    if (column != null) {
      var width = getWidthValue(column, columns, propName);
      if (width != null) {
        return (0, _styled.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n        margin-left: ", ";\n      "])), width);
      }
    }
    return undefined;
  };
};
var getOrder = function getOrder(bp, initial) {
  return function (props) {
    var order = initial && props.order != null ? props.order : props[bp + "Order"];
    return order != null ? (0, _styled.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n        order: ", ";\n      "])), order) : undefined;
  };
};
var filteredProps = ['size', 'offset', 'alignSelf', 'textAlign', 'order', 'fluid'];
var GridComponent = (0, _createGridComponent.default)('Column', filteredProps);
var Column = (0, _styled.default)(GridComponent)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-left: ", ";\n  padding-right: ", ";\n  align-self: ", ";\n  text-align: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), (0, _styled.prop)('theme.grid.gutter'), (0, _styled.prop)('theme.grid.gutter'), (0, _styled.prop)('alignSelf', 'auto'), (0, _styled.prop)('textAlign', 'inherit'), (0, _styled.ifProp)('debug', (0, _styled.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteralLoose2.default)(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n      border: 1px solid rgba(86, 61, 124, 0.2);\n      background-color: rgba(86, 61, 124, 0.15);\n    "])), (0, _styled.prop)('theme.grid.gutter'), (0, _styled.prop)('theme.grid.gutter'))), (0, _styled.ifProp)('fluid', (0, _styled.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteralLoose2.default)(["\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n    "])))), function (props) {
  var keys = props.theme.media.keys;
  var minKey = keys[0];
  return keys.map(function (bp) {
    var initial = bp === minKey;
    var style = (0, _styled.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteralLoose2.default)(["\n        ", ";\n        ", ";\n        ", ";\n      "])), getWidth(bp, initial), getOffset(bp, initial), getOrder(bp, initial));
    return initial ? style : (0, _styled.mediaMin)(bp, style);
  });
});
Column.displayName = 'Column';
var _default = exports.default = Column;